export default __webpack_public_path__ + "img/InterDisplay-LightItalic_8d34583.woff2";